import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { playNextLogo, playAtEndLogo } from 'images';

import { ListButton } from 'components';


/**
 * @desc Track playlist options dropdown menu component
 * @memberof components/playlist/PlaylistTrackOptions
 *
 * @param  {[Playlist]} playlists                   [List of available playlists]
 *
 * @param  {Function} t                      		[i18 string getter (Autowired)]
 * @param  {Function} onPlaylistClick               [Playlist to add selection handler]
 * @param  {Function} onPlayNextClick               ['Play next' option click handler]
 * @param  {Function} onPlayLaterClick              ['Play later' option click handler]
 * @param  {Function} onCreatePlaylistClick         ['Create playlist' option click handler]
 *
 * @type {Component}
 */
@withTranslation()
export default class TrackPlaylistMenu extends React.PureComponent {
	static propTypes = {
		playlists: PropTypes.arrayOf(PropTypes.object),

		t: PropTypes.func.isRequired,
		onPlaylistClick: PropTypes.func.isRequired,
		onPlayNextClick: PropTypes.func.isRequired,
		onPlayLaterClick: PropTypes.func.isRequired,
		onCreatePlaylistClick: PropTypes.func.isRequired
	}

	/* Rendering */

	renderPlayNextBtn = () => {
		const { t } = this.props;

		return (
			<React.Fragment>
				<img src={playNextLogo} className="w-2 inline-block" alt=">" />
				<span className="text-xs px-2 inline-block">
					{ t('general.play-next') }
				</span>
			</React.Fragment>
		);
	}

	renderPlayLaterBtn = () => {
		const { t } = this.props;

		return (
			<React.Fragment>
				<img src={playAtEndLogo} className="w-2 inline-block" alt="<" />
				<span className="text-xs px-2 inline-block">
					{ t('general.play-later') }
				</span>
			</React.Fragment>
		);
	}

	renderPlaylistBtn = (playlist) => {
		const { onPlaylistClick } = this.props;

		return (
			<ListButton
				key={playlist.playlistid}
				name={'+ ' + playlist.name}
				onClick={() => onPlaylistClick(playlist)} />
		);
	}

	renderNewPlaylistBtn = () => {
		const { t, onCreatePlaylistClick } = this.props;

		return (
			<button
				type="button"
				className="bg-lightNavy px-4 py-2 text-white text-xs focus:outline-none w-full"
				onClick={onCreatePlaylistClick}>
				{ t('playlist.create-new-playlist') }
			</button>
		);
	}

	render() {
		const { playlists, onPlayNextClick, onPlayLaterClick } = this.props;

		return (
			<React.Fragment>
				<ListButton
					key={1}
					render={this.renderPlayNextBtn}
					onClick={onPlayNextClick} />
				<ListButton
					key={2}
					render={this.renderPlayLaterBtn}
					onClick={onPlayLaterClick} />

				<hr className="w-full bg-gray-250" style={{ height: '1px' }} />

				{ playlists.map(this.renderPlaylistBtn) }
				{ this.renderNewPlaylistBtn() }
			</React.Fragment>
		);
	}
}
